import { Component, Inject, inject } from '@angular/core';
import { CancelledVisaDetails } from '../../models/cancelled-visa-details';
import { Person } from '../../data/person';
import { NonNullableFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Validators } from '@angular/forms';
import { resolvePersonOption } from '../../../helpers/person.helpers';

@Component({
  selector: 'app-cancelled-visa-dialog',
  templateUrl: './cancelled-visa-dialog.component.html',
  styleUrl: './cancelled-visa-dialog.component.scss'
})
export class CancelledVisaDialogComponent {
  cancelledVisaDetails!: CancelledVisaDetails;
    personOptions: Array<{ value: Person, label: string }> = [];

    formBuilder = inject(NonNullableFormBuilder);

    cancelledVisaDetailsForm = this.formBuilder.group({
      cancelled: [''],
      person: [null as Person | null]
  
    });
  
    constructor(public dialogRef: MatDialogRef<CancelledVisaDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
     this.cancelledVisaDetails = data.cancelledVisaDetails;
     this.personOptions = data.personOptions;
  
    }

  ngOnInit(): void {

    this.initializeForm();
    this.applyValidators();

  }

  private initializeForm(): void{
    this.cancelledVisaDetailsForm.patchValue({
      cancelled: this.cancelledVisaDetails.cancelled,
      person: resolvePersonOption(this.cancelledVisaDetails.person, this.personOptions)
    });

    this.cancelledVisaDetailsForm.valueChanges.subscribe(formValue => {
      this.cancelledVisaDetails.cancelled = formValue.cancelled || '';
      this.cancelledVisaDetails.person = formValue.person || new Person();
    });

  }
  
    get dialogTitle(): string {
      return 'Add Visa Cancelled';
    }
  
      private applyValidators(): void {
        const cancelledControl = this.cancelledVisaDetailsForm.controls.cancelled;
        const personControl = this.cancelledVisaDetailsForm.controls.person;
        cancelledControl.setValidators([Validators.required]);
        personControl.setValidators([Validators.required]);
        cancelledControl.updateValueAndValidity();
        personControl.updateValueAndValidity();
      }


cancel() {
  this.dialogRef.close();
}
ok() {
  if(this.cancelledVisaDetailsForm.valid){
      this.dialogRef.close(this.cancelledVisaDetails);
    }
    else{
      this.cancelledVisaDetailsForm.markAllAsTouched();
      return;
    }
}
}
